import { TERMS } from "@/data/tokens";

export type ScreeningPeriodKey = "t1" | "t3" | "t4";

const LABELS: Record<ScreeningPeriodKey, string> = TERMS.reduce((acc, term) => {
  acc[term.id.toLowerCase() as ScreeningPeriodKey] = term.label;
  return acc;
}, {} as Record<ScreeningPeriodKey, string>);

export function screeningPeriodLabel(period: ScreeningPeriodKey): string {
  return LABELS[period] ?? period.toUpperCase();
}

export function readableList(items: readonly string[]): string {
  if (items.length <= 1) return items[0] ?? "";
  if (items.length === 2) return `${items[0]} and ${items[1]}`;
  return `${items.slice(0, -1).join(", ")}, and ${items[items.length - 1]}`;
}

export function screeningPeriodList(periods: readonly ScreeningPeriodKey[]): string {
  return readableList(periods.map(screeningPeriodLabel));
}
